<template>
   <div >
    <v-dialog
      v-model="dialog"
      width="500"
      @click:outside="close"
    >
      <template v-slot:activator="{ on, attrs }">

        <v-btn
            v-if="mode !== 'edit'"
            color="primary"
            class="mb-2"
            dark
            v-bind="attrs"
            v-on="on"
        >
        {{  add_button_label }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2" style="word-break: break-word">
            {{  dialog_label }}
        </v-card-title>

        <v-card-text>
            <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
            >
              <!-- Selector de tópico: solo para n1 (incluye opción "tema propio") -->
              <v-select
                  v-if="narrativeType === 'n1'"
                  v-model="selected_topic"
                  :items="topicsWithCustomOption"
                  :item-text="`topic_${$i18n.locale}`"
                  item-value="id"
                  :label="$t('active_source.narrative_topic')"
                  clearable
              ></v-select>

              <!-- Campo de texto para tema propio (n1 con opción __custom__) -->
              <v-text-field
                  v-if="narrativeType === 'n1' && selected_topic === '__custom__'"
                  v-model="customTopicText"
                  :label="$t('narratives_block.n1_add_topic')"
                  :rules="nameRules"
                  class="mt-1"
              ></v-text-field>

              <!-- Título: para n1 cuando hay subtema seleccionado (auto-llenado) o en modo edición -->
              <v-text-field
                  v-if="narrativeType === 'n1' && (isSubTopicSelected || mode === 'edit')"
                  v-model="title"
                  :label="$t('active_source.narrative_title')"
                  :rules="nameRules"
              ></v-text-field>

              <!-- Texto de la narrativa -->
              <v-textarea
                  v-model="narrative"
                  :label="narrativeType === 'closing'
                    ? $t('closing_block.question')
                    : narrativeType === 'n2'
                      ? $t('narratives_block.n2_subtitle')
                      : $t('active_source.narrative_description')"
                  :placeholder="narrativeType === 'closing'
                    ? $t('closing_block.placeholder')
                    : narrativeType === 'n2'
                      ? $t('narratives_block.n2_placeholder')
                      : ''"
                  :rules="nameRules"
                  auto-grow
                  rows="4"
              ></v-textarea>

            </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
         

          <v-btn
            color="default"
            text
            @click="cancel"
          >
            {{ $t('globals.cancel') }}
          </v-btn>
           <v-btn
              color="primary"
              text
              @click="saveNarrative"
            >
            {{ button_action_text }}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>


<script>

import { useMainStore } from '@/store/main';
import { mapStores, mapState} from 'pinia';

export default {

  props: {
    showNarrativeDialog: { default: false },
    mode:String,
    label:String,
    network_mode_id: Number,
    item:Object,
    narrativeTopics:Array,
    // 'n1' (con tópicos), 'n2' (texto libre, sin tópico), 'closing' (pregunta de cierre)
    narrativeType: { type: String, default: 'n1' },
    cycleId: { type: Number, default: null },
  },
    data () {
      return {
        valid:false,
        title: '',
        narrative: '',
        dialog:false,
        selected_topic:null,
        customTopicText: '',

        nameRules: [
            v => !!v || this.$t('rules.field_required'),
          ],

      }
  },

  watch: {
    showNarrativeDialog: {

      handler: function (val) {

        this.dialog = val

      },
      // deep: true,
       immediate:true

    },

    mode: {

      handler: function (val) {

        if (val === 'edit') {
          console.log(this.item);
          this.title = this.item.title,
          this.narrative = this.item.narrative,
          this.selected_topic = this.item.id_topic
        }

      },
      // deep: true,
      immediate: true

    },

    selected_topic(val) {
      if (this.narrativeType !== 'n1') return;
      if (val && typeof val === 'string' && val.startsWith('__sub_')) {
        const locale = this.$i18n.locale;
        const topic = this.expandedN1Topics.find(t => t.id === val);
        if (topic) {
          this.title = topic[`topic_${locale}`] || topic.topic_es;
        }
      } else if (val === '__custom__') {
        this.title = '';
      }
    },
  },
  computed: {
      

    ...mapState(useMainStore, ["logged_user", "selected_cycle"]),
        
    ...mapStores(useMainStore),

    expandedN1Topics() {
      if (!this.narrativeTopics || !this.narrativeTopics.length) return [];
      const n1 = this.narrativeTopics[0];
      let topicsEs = [], topicsEn = [];
      try {
        topicsEs = JSON.parse(n1.topic_es || '[]');
        topicsEn = JSON.parse(n1.topic_en || '[]');
      } catch {
        topicsEs = (n1.topic_es || '').split(',').map(s => s.trim()).filter(Boolean);
        topicsEn = (n1.topic_en || '').split(',').map(s => s.trim()).filter(Boolean);
      }
      return topicsEs.map((text, i) => ({
        id: `__sub_${i}__`,
        topic_es: text,
        topic_en: topicsEn[i] || text,
        parent_id: n1.id,
      }));
    },

    isSubTopicSelected() {
      return typeof this.selected_topic === 'string' && this.selected_topic.startsWith('__sub_');
    },

    topicsWithCustomOption() {
      const customItem = {
        id: '__custom__',
        topic_es: '+ ' + this.$t('narratives_block.n1_add_topic'),
        topic_en: '+ ' + this.$t('narratives_block.n1_add_topic'),
      };
      if (this.narrativeType === 'n1') {
        return [...this.expandedN1Topics, customItem];
      }
      return [...(this.narrativeTopics || []), customItem];
    },

    label_text() {

      return this.mode === 'create' ? this.$t('globals.add') : this.$t('globals.edit');

    },

    button_action_text() {

      return this.mode === 'create' ? this.$t('globals.add') : this.$t('globals.update');

      },

    dialog_label() {

      return this.label_text + ' ' + this.label;
    },

    add_button_label() {
      return this.$t('narratives_block.add_narrative');
    }

  
  },

  methods: {
      
    validate() {
        
        return this.$refs.form.validate()
      },
    reset() {
        
        this.$refs.form.reset()
      },
    resetValidation() {
        
        this.$refs.form.resetValidation()
      },


    saveNarrative() {

      if (this.mode === 'create') {
        this.createNarrative();
    
      }
      else {
        this.updateNarrative();
      }
   
    },
    

    createNarrative() {

        if (this.validate()){

            let resolvedTitle, resolvedTopicId;
            if (this.narrativeType === 'n2') {
              // N2: título automático desde el tema N2, id_topic = id del registro
              const n2Topic = this.narrativeTopics?.[0];
              const locale  = this.$i18n.locale;
              resolvedTitle   = n2Topic ? (n2Topic[`tema_${locale}`] || n2Topic.tema_es || '') : '';
              resolvedTopicId = n2Topic ? n2Topic.id : null;
            } else {
              const isCustomTopic = this.selected_topic === '__custom__';
              const isSubTopic    = this.isSubTopicSelected;
              resolvedTitle = isCustomTopic ? this.customTopicText : this.title;
              if (isCustomTopic) {
                resolvedTopicId = null;
              } else if (isSubTopic) {
                const sub = this.expandedN1Topics.find(t => t.id === this.selected_topic);
                resolvedTopicId = sub ? sub.parent_id : null;
              } else {
                resolvedTopicId = this.selected_topic;
              }
            }

            const data = {
                "title": resolvedTitle,
                "narrative": this.narrative,
                "cycle_id": this.cycleId != null ? this.cycleId : this.mainStore.selected_cycle,
                "user_email":this.logged_user.email,
                "network_mode_id":this.network_mode_id,
                "id_topic": resolvedTopicId
              };

              this.$axios.post(process.env.VUE_APP_BACKEND_URL+'/user/narrative/add', data)
                .then(async response => {
            
                  const narrative= response.data.response; 
                  this.$alertify.success(this.$t(response.data.message));
                  this.$emit('new_narrative', narrative);
                  this.close();

            
                  })
                .catch(error => {
                    this.$alertify.error(this.$t(error.message));
                    console.error('There was an error!', error.message);
                    console.error( error);
                    this.close();
              });

              
        }  
    },
      

      updateNarrative() {

        if (this.validate()) {

          const data = {
            "narrative_id":this.item.id,
            "title": this.title,
            "narrative": this.narrative,
            "cycle_id": this.cycleId != null ? this.cycleId : this.mainStore.selected_cycle,
            "user_email": this.logged_user.email,
            "network_mode_id": this.network_mode_id,
            "id_topic": this.selected_topic
          };

          this.$axios.post(process.env.VUE_APP_BACKEND_URL + '/user/narrative/update', data)
            .then(async response => {

              // const narrative = response.data.response;
              
              this.$alertify.success(this.$t(response.data));
              this.$emit('narrative_updated',data);
              this.close();
            })
            .catch(error => {
              this.$alertify.error(this.$t(error.message));
              console.error('There was an error!', error.message);
              console.error(error);
              this.close();
            });
        }
      },


      close() {

        this.reset();
        this.resetValidation();
        this.customTopicText = '';
        this.$emit('close');
        this.dialog = false;
      },

      cancel(){
        this.close();

      }
    },
   
  }

</script>
